var Source = /* @__PURE__ */ ((Source2) => {
  Source2["MIDDLEWARE"] = "M";
  Source2["DEVICE"] = "D";
  Source2["BUSINESS_LOCALLY"] = "B";
  Source2["STREAM"] = "S";
  Source2["AUTHENTICATION"] = "A";
  Source2["PARTNER"] = "P";
  Source2["DRM"] = "R";
  Source2["CASTING"] = "C";
  Source2["GENERAL"] = "G";
  return Source2;
})(Source || {});
var Platform = /* @__PURE__ */ ((Platform2) => {
  Platform2["ANDROID"] = "1";
  Platform2["ANDROID_TV"] = "2";
  Platform2["IOS"] = "3";
  Platform2["APPLE_TV"] = "4";
  Platform2["FIRE_TV"] = "5";
  Platform2["ROKU"] = "6";
  Platform2["WEB"] = "7";
  Platform2["CHROMECAST"] = "8";
  Platform2["TIZEN"] = "9";
  Platform2["WEBOS"] = "10";
  Platform2["HISENSE"] = "11";
  Platform2["ZEASN"] = "12";
  return Platform2;
})(Platform || {});
var Location = /* @__PURE__ */ ((Location2) => {
  Location2["LOGIN"] = "10";
  Location2["SPLASH_SCREEN"] = "11";
  Location2["PDP"] = "12";
  Location2["SETTINGS"] = "13";
  Location2["EPG"] = "14";
  Location2["SEARCH"] = "15";
  Location2["PLAYER_BEFORE_VIDEO_START"] = "16";
  Location2["PLAYER_PLAYBACK"] = "17";
  Location2["CASTING_CHROMECAST"] = "18";
  Location2["HOME_PAGE"] = "19";
  Location2["LIVE_PAGE"] = "20";
  Location2["CATALOG_PAGE"] = "21";
  Location2["SPORTS_PAGE"] = "22";
  Location2["KIDS_PAGE"] = "23";
  Location2["LANDER"] = "24";
  Location2["MINI_EPG"] = "25";
  Location2["PROFILE_CREATE"] = "26";
  Location2["PROFILE_EDIT"] = "27";
  Location2["PROFILE_DELETE"] = "28";
  Location2["PIN"] = "29";
  Location2["TV_ACTIVATION"] = "30";
  Location2["ZAPPING"] = "31";
  Location2["SEE_MORE_LANDER"] = "32";
  Location2["BACKGROUND_SERVICE"] = "33";
  Location2["MY_LIST"] = "34";
  Location2["IAP_ACCOUNT_CREATE"] = "35";
  Location2["IAP_ACCOUNT_DELETE"] = "36";
  Location2["IAP_PURCHASE_FLOW"] = "37";
  Location2["CASTING_CAST_CONNECT"] = "38";
  Location2["CASTING_AIRPLAY"] = "39";
  return Location2;
})(Location || {});
var ErrorCode = /* @__PURE__ */ ((ErrorCode2) => {
  ErrorCode2["BLACKOUT"] = "01";
  ErrorCode2["MOBILE_BLACKOUT"] = "02";
  ErrorCode2["LOST_WIFI_CONNECTION"] = "03";
  ErrorCode2["LOST_INTERNET_CONNECTION"] = "04";
  ErrorCode2["NOT_IN_REGION"] = "05";
  ErrorCode2["REGION_BLOCK"] = "06";
  ErrorCode2["AUTHORIZER_CONCURRENT_USER_LIMIT"] = "07";
  ErrorCode2["AUTHORIZER_CONCURRENT_CHANNEL_LIMIT"] = "08";
  ErrorCode2["AUTHORIZER_CONCURRENT_DEVICE_LIMIT"] = "09";
  ErrorCode2["AUTHORIZER_NOT_VALID_LOGIN_TOKEN"] = "10";
  ErrorCode2["AUTHORIZER_NOT_VALID_CUSTOMER_TOKEN"] = "11";
  ErrorCode2["AUTHORIZER_NOT_VALID_ASSET_TOKEN"] = "12";
  ErrorCode2["AUTHORIZER_NOT_VALID_REFRESH_TOKEN"] = "13";
  ErrorCode2["AUTHORIZER_OTHERS"] = "14";
  ErrorCode2["SESSION_EXPIRED"] = "15";
  ErrorCode2["LOGIN_REFRESH_TOKEN_FAILED"] = "16";
  ErrorCode2["DRM_FAILED"] = "17";
  ErrorCode2["NOT_IN_PACKAGE_OTT"] = "18";
  ErrorCode2["NOT_IN_PACKAGE_DTH"] = "19";
  ErrorCode2["NOT_IN_PACKAGE_B2B2C"] = "20";
  ErrorCode2["DEVICE_LIMIT_REACHED"] = "21";
  ErrorCode2["USER_INACTIVE"] = "22";
  ErrorCode2["NOT_ENOUGH_DATA_TO_PLAY_CONTENT"] = "23";
  ErrorCode2["REQUEST_TIMEOUT"] = "24";
  ErrorCode2["LOGOUT"] = "25";
  ErrorCode2["INVALID_PLAYLOAD_RESPONSE"] = "26";
  ErrorCode2["TOKEN_WITHOUT_CHANNELS"] = "27";
  ErrorCode2["MISSING_DATA"] = "28";
  ErrorCode2["LIMIT_STALLED"] = "29";
  ErrorCode2["PARENTAL_RESTRICTION"] = "30";
  ErrorCode2["NOT_IN_PACKAGE_GOOGLE_IAP_OTT"] = "31";
  ErrorCode2["ACCOUNT_WITHOUT_PACKAGE"] = "32";
  ErrorCode2["SSL_HANDSHAKE_ERROR"] = "33";
  ErrorCode2["AUTHORIZER_CONCURRENT_PROVIDER_LIMIT"] = "34";
  ErrorCode2["CAST_AUTO_LOGIN_FAILED"] = "35";
  ErrorCode2["CAST_ERROR_CHROMECAST"] = "36";
  ErrorCode2["CAST_ERROR_AIRPLAY"] = "37";
  ErrorCode2["BET_NOT_ALLOWED"] = "38";
  ErrorCode2["INTERACTIVITY_MODULE_INCOMPATIBLE"] = "39";
  ErrorCode2["REFRESH_TOKEN_EXPIRED"] = "40";
  ErrorCode2["RECAPTCHA_SERVER_ERROR"] = "41";
  ErrorCode2["REFRESH_TOKEN_REVOKED"] = "50";
  ErrorCode2["IMPOSSIBLE_TO_CREATE_REQUEST"] = "96";
  ErrorCode2["PLAYER_EXCEPTION"] = "97";
  ErrorCode2["OTHER_HTTP_ERROR"] = "98";
  ErrorCode2["UNEXPECTED_ERROR"] = "99";
  return ErrorCode2;
})(ErrorCode || {});
const MapPlatformToName = {
  ["1" /* ANDROID */]: "Android",
  ["2" /* ANDROID_TV */]: "Android TV",
  ["3" /* IOS */]: "iOS",
  ["4" /* APPLE_TV */]: "Apple TV",
  ["5" /* FIRE_TV */]: "Fire TV",
  ["6" /* ROKU */]: "Roku",
  ["7" /* WEB */]: "Web",
  ["8" /* CHROMECAST */]: "Chromecast",
  ["9" /* TIZEN */]: "Tizen",
  ["10" /* WEBOS */]: "WebOS",
  ["11" /* HISENSE */]: "Hisense",
  ["12" /* ZEASN */]: "Zeasn"
};

export { ErrorCode, Location, MapPlatformToName, Platform, Source };
//# sourceMappingURL=types.js.map
